<template>
	<div class="login-frame">
		<Form class="root-forget-account" ref="loginForm" :model="form" :rules="validationRules" :validOnChange="true">
			<FormItem :showLabel="false" >
        <span style="font-size:20px;">为了您的信息安全，请修改密码后进入系统！</span>
			</FormItem>
      <FormItem :showLabel="false" required prop="original" label="旧密码" style="margin-bottom:10px;">
        <div class="h-input h-input-prefix-icon">
          <i class="fa fa-lock"></i>
          <Input type="password" ref="original" placeholder="请输入旧密码" v-model="form.original" autocomplete="off" class="forget-input" @keyup.enter.native="focusNewPass"/>
        </div>
      </FormItem>
			<FormItem :showLabel="false" required prop="newPassword" label="新密码" style="margin-bottom:10px;">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-lock"></i>
					<Input type="password" ref="newPassword" placeholder="请输入新密码" v-model="form.newPassword" autocomplete="off" class="forget-input" @keyup.enter.native="focusRepeat"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" required prop="repeatPassword" label="确认新密码" style="margin-bottom:10px;">
				<div class="h-input h-input-prefix-icon">
					<i class="fa fa-lock"></i>
					<Input type="password" ref="repeatPassword" placeholder="请再次输入新密码" v-model="form.repeatPassword" autocomplete="off" class="forget-input" @keyup.enter.native="changeSubmit"/>
				</div>
			</FormItem>
			<FormItem :showLabel="false" class="!pb-0px">
				<Button @click="changeSubmit" :loading="loading" class="root-forget-btn" >修改并进入系统</Button>
			</FormItem>
		</Form>
	</div>
</template>
<script>

	export default {
		name: 'StrongPassword',
		data() {
			return {
				form: {
          original: "",
					newPassword: "",
					repeatPassword: "",
				},
        validationRules: {
          required: ["original", "newPassword", "repeatPassword"],
          rules:{
            newPassword:{
              valid:{
                pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_][\x00-\xff]{7,19}$/,
                message: "密码必须包含大写字母、小写字母、数字、特殊字符中的三种，长度8到20位的半角字符"
              }
            }
          },
          combineRules: [{
            refs: ['newPassword', 'repeatPassword'],
            valid: {
              valid: 'equal',
              message: '两次输入的密码不一致'
            }
          }]
        },
				loading: false
			};
		},
		methods: {
      focusNewPass() {
        let validResult = this.$refs.loginForm.validField('original');
        if (validResult.valid) {
          this.$refs.newPassword.$el.focus()
        }

      },
      focusRepeat() {
        let validResult = this.$refs.loginForm.validField('newPassword');
        if (validResult.valid) {
          this.$refs.repeatPassword.$el.focus()
        }
      },
			changeSubmit() {
				let validResult = this.$refs.loginForm.valid();
				if (validResult.result) {
					this.loading = true;
					this.$api.common.updatePwdNotOut(this.form).then(() => {
						this.$Message("密码修改成功！");
            window.location.replace("/");
					}).finally(() => {
						this.loading = false;
					});
				}
			}
		},
    created() {
      this.$nextTick(() => {
        this.$refs.original.$el.focus()
      })
    },
	}
</script>

<style lang="less" scoped>
	.root-forget-account {
		margin-top: 30px;
	}

	.forget-input {
		height: 45px;
		border-radius: 6px;
	}
	.root-forget-btn {
		height: 40px;
		background-color: #006dfd;
		border-radius: 20px;
		color: #fff;
		cursor: default;
		width: 100%;
	}
	.root-forget-btn:hover, .root-forget-btn:focus {
		background-color: #006dfd;
		border-radius: 20px;
		color: #fff;
	}
</style>
